import { post } from './httpRequest';

export const sendBeacon = (url: string, data: unknown): boolean => {
  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    return navigator.sendBeacon(url, blob);
  }
  post(url, data, {})
    .then(() => {
      // no need to do anything on success
    })
    .catch(() => {
      // no need to do anything on failure
    });
  return false;
};
